// extracted by mini-css-extract-plugin
module.exports = {"container":"main_container__1M2WF","i_min":"main_i_min__32cHr"};